const currentYear = () => {
    const dateObj = new Date()
    const getYear = dateObj.getUTCFullYear().toString()
    return getYear      
}

module.exports = currentYear